//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
    'use strict';

    var curalate = angular.module('curalate');

    curalate.service('ProductTaggingService', ['$http', '$q', '$rootScope', 'PromiseService', 'RestBaseUrl', 'UniversalImageActionsTrackingService',
        function($http, $q, $rootScope, PromiseService, RestBaseUrl, UniversalImageActionsTrackingService) {
            var self = this;

            var products;
            var productsErrorState;
            var itemId;
            var originalProducts;
            var validateProducts;
            var saveProductsAsync;
            var convertProductIdsToNumbers;
            var convertCrawledImageUrlsToObjects;
            var convertCrawledImageUrlsToStrings;
            var affiliateParams;
            var updateProductPositionsAndLabels;
            var hasMissingProductImageOrName;
            var hasInvalidProductUrl;
            var sortProducts;
            var VALIDATION_ERRORS;

            VALIDATION_ERRORS = {
                MissingImageOrName: 'To save, all products need images and names.',
                InvalidUrl: 'To save, all product URLs must be valid.'
            };

            this.saveProductTagsAsync = function(newProducts) {
                var params = {
                    products: newProducts
                };

                if (!itemId) {
                    var e = 'Attempting to save products without an item ID';
                    throw e;
                }
                if (affiliateParams) {
                    params.isAffiliate = true;
                }
                return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/universal-image-actions/items/' + itemId + '/products', params));
            };

            this.getProducts = function() {
                var returnValue;
                if (products !== undefined) {
                    returnValue = products;
                } else {
                    var e = 'Product Tag Manager: Products not defined';
                    throw e;
                }
                return returnValue;
            };

            this.setProducts = function(newProducts, setItemId) {
                var sortedProducts = sortProducts(newProducts);

                if (setItemId) {
                    itemId = setItemId;
                }

                if (!angular.equals(products, sortedProducts)) {
                    if (products === undefined) {
                        originalProducts = sortedProducts;
                    }

                    products = sortedProducts;
                    $rootScope.$broadcast('uia:products-changed', products);
                }
            };

            this.setAffiliateData = function(newAffiliateParams) {
                affiliateParams = angular.copy(newAffiliateParams);
            };

            this.addProductAsync = function(newProduct) {
                var newProducts = angular.copy(productsErrorState || products);

                UniversalImageActionsTrackingService.setProduct(newProduct);
                UniversalImageActionsTrackingService.saveRoute();

                newProducts.push(newProduct);
                return saveProductsAsync(newProducts);
            };

            this.removeProductAsync = function(productIndex) {
                var newProducts = angular.copy(productsErrorState || products);

                newProducts.splice(productIndex, 1);
                return saveProductsAsync(newProducts);
            };

            this.updateProductsAsync = function(newProducts) {
                return saveProductsAsync(sortProducts(newProducts));
            };

            this.getOriginalProducts = function() {
                return originalProducts;
            };

            this.updateProductAsync = function(newProduct, productIndex) {
                var newProducts = angular.copy(productsErrorState || products);
                var originalProduct = newProducts[productIndex];

                if (!newProduct.fileId && originalProduct) {
                    newProduct.fileId = originalProduct.fileId;
                }

                newProducts[productIndex] = newProduct;
                return saveProductsAsync(newProducts);
            };

            saveProductsAsync = function(newProducts) {
                var error;
                var errorState;
                var productsPromise;

                convertProductIdsToNumbers(newProducts);
                convertCrawledImageUrlsToStrings(newProducts);
                updateProductPositionsAndLabels(newProducts);
                newProducts = sortProducts(newProducts);
                error = validateProducts(newProducts);

                if (error) {
                    productsErrorState = angular.copy(newProducts);

                    errorState = {
                        errorMessage: error,
                        products: newProducts,
                        validationError: true
                    };

                    $rootScope.$broadcast('uia:invalid-products', errorState);
                    return $q.reject(errorState);
                }

                productsPromise = self.saveProductTagsAsync(newProducts).then(function(response) {
                    var responseProducts = response.products;

                    if (!angular.equals(products, responseProducts) || productsErrorState) {
                        products = sortProducts(responseProducts);

                        $rootScope.$broadcast('uia:products-changed', products);
                    }
                    productsErrorState = null;

                    return angular.copy(products);
                }).catch(function(e) {
                    productsErrorState = newProducts;
                    convertCrawledImageUrlsToObjects();

                    return $q.reject(e);
                });

                return productsPromise;
            };

            validateProducts = function(newProducts) {
                var containsMultipleProducts = newProducts && newProducts.length > 1;
                var returnValue;

                if (containsMultipleProducts && hasMissingProductImageOrName(newProducts)) {
                    returnValue = VALIDATION_ERRORS.MissingImageOrName;
                } else if (hasInvalidProductUrl(newProducts)) {
                    returnValue = VALIDATION_ERRORS.InvalidUrl;
                } else {
                    returnValue = null;
                }
                return returnValue;
            };

            // We need the product ids to be Longs when updating Like2Buy items
            convertProductIdsToNumbers = function(newProducts) {
                _(newProducts).each(function(product) {
                    product.id = product.id ? parseInt(product.id, 10) : null;
                });
            };

            // The db expects any lists of crawled image urls to be a JSON blob
            convertCrawledImageUrlsToStrings = function(newProducts) {
                _(newProducts).each(function(product) {
                    if (product.crawledImageUrls) {
                        product.crawledImageUrls = JSON.stringify(product.crawledImageUrls);
                    }
                });
            };

            convertCrawledImageUrlsToObjects = function(newProducts) {
                _(newProducts).each(function(product) {
                    if (product.crawledImageUrls) {
                        product.crawledImageUrls = JSON.parse(product.crawledImageUrls);
                    }
                });
            };

            updateProductPositionsAndLabels = function(newProducts) {
                var nextPosition = 1;
                _.chain(newProducts).sortBy(function(product) {
                    return product.spatialTag ? product.spatialTag : undefined;
                }).each(function(product) {
                    product.position = nextPosition;
                    if (product.spatialTag) {
                        product.spatialTag.label = nextPosition.toString();
                    }
                    nextPosition++;
                    return product;
                });
            };

            hasMissingProductImageOrName = function(newProducts) {
                return _(newProducts).some(function(product) {
                    return !product.imageUrl || !product.name;
                });
            };

            hasInvalidProductUrl = function(newProducts) {
                return _(newProducts).some(function(product) {
                    var url = product.destinationUrl;

                    return !url || url.trim().length === 0;
                });
            };

            sortProducts = function(productsList) {
                return _(productsList).sortBy(function(product) {
                    return product.position;
                });
            };
        }
    ]);
})();
